import styles from './styles';

import React from 'react';
import DocumentTitle from 'react-document-title';
import type { RouteComponentProps } from 'react-router-dom';

import { computed } from 'mobx';
import { Provider, inject, observer } from 'mobx-react';

import { withStyles } from '@material-ui/core';
import type { WithStyles } from '@material-ui/core';

import type ProviderStore from 'connect/web/src/stores/provider-store';
import type SearchStore from 'connect/web/src/stores/search-store';

import classnames from 'classnames';
import queryString from 'query-string';
import HistoryStore, { HistoryStoreContext } from '../stores/history-store';
import ContentRoutes from './controls/content';
import Footer from './controls/footer';
import GdprCookie from './controls/gdpr-cookie';
import Header from './controls/header';
import IOSAddToHomeScreen from './controls/ios-add-to-home-screen';
import RecaptchaProvider from './controls/recaptcha';
import RedirectPage from './controls/redirect-screen';

interface IProps extends WithStyles<typeof styles>, RouteComponentProps {
  providerStore?: ProviderStore;
  searchStore?: SearchStore;
}

@inject('providerStore', 'searchStore')
@observer
class Shell extends React.Component<IProps> {
  historyStore: HistoryStore;

  constructor(props: IProps) {
    super(props);
    let { history, location, match } = this.props;
    this.historyStore = new HistoryStore();
    this.historyStore.history = history;
    this.historyStore.location = location;
    this.historyStore.redirecting = queryString.parse(location.search)?.redirect === 'true';
    this.historyStore.match = match;
    this.historyStore.currentPath = window.location.pathname || '';
    this.historyStore.analyticsEnabled = this.props.providerStore!.analyticsEnabled;
  }

  public render() {
    const { siteContainer, contentContainer } = this.props.classes;

    return (
      <RecaptchaProvider>
        <DocumentTitle title={this.siteTitle}>
          <Provider historyStore={this.historyStore}>
            <HistoryStoreContext.Provider value={this.historyStore}>
              <>
                <div className={siteContainer + ' ' + this.msExplorerClass}>
                  {!this.historyStore.redirecting && <Header />}
                  <div className={contentContainer}>
                    <ContentRoutes {...this.props} />
                  </div>
                  {!this.historyStore.redirecting && <Footer />}
                </div>
                {!this.historyStore.redirecting && (
                  <>
                    <GdprCookie />
                    <IOSAddToHomeScreen />
                  </>
                )}
              </>
            </HistoryStoreContext.Provider>
          </Provider>
        </DocumentTitle>
      </RecaptchaProvider>
    );
  }

  @computed
  private get siteTitle(): string {
    const {
      siteTitle,
      license: { isClick, isEClinic, isGDS, isPPM, isTM3Connect, isTM3Essentials, isCaseflow }
    } = this.props.providerStore!;
    if (!siteTitle) {
      return (
        'Connect powered by ' +
          classnames({
            TM3: isTM3Connect || isTM3Essentials,
            Click: isClick,
            Caseflow: isCaseflow,
            GDS: isGDS,
            'E-Clinic': isEClinic,
            PPM: isPPM
          }) ?? 'Blue Zinc'
      );
    }
    return siteTitle;
  }

  @computed
  private get msExplorerClass(): string {
    const { msExplorer } = this.props.classes;
    const version = window.document.documentMode || 0;

    return version > 0 ? msExplorer : '';
  }
}

export default withStyles(styles)(Shell);
